export default class Table {
  constructor() {
    this.init();
  }
  init() {
    $(function(){
      setTimeout(() => {
        $("table[data-resizable-columns]").resizableColumns({
          store: store
        });
      }, 100);
    });
  }
}
